const general = {
  state: {
    overlay_isOpen: false,
    overlay_content: '',
    overlay_popup_isOpen: false,
    overlay_popup_content: '',
    overlay_popup_cb: ''
  },
  getters: {
    overlay_isOpen(state) { return state.overlay_isOpen; },
    overlay_content(state) { return state.overlay_content; },
    overlay_popup_isOpen(state) { return state.overlay_popup_isOpen; },
    overlay_popup_content(state) { return state.overlay_popup_content; },
    overlay_popup_cb(state) { return state.overlay_popup_cb; }
  },
  mutations: {
    overlay_isOpen(state, active) {
      state.overlay_isOpen = active;
    },
    overlay_content(state, content) {
      state.overlay_content = content;
    },
    overlay_popup_isOpen(state, active) {
      state.overlay_popup_isOpen = active;
    },
    overlay_popup_content(state, content) {
      state.overlay_popup_content = content;
    },
    overlay_popup_cb(state, cb) {
      state.overlay_popup_cb = cb;
    }
  }
};

export default general;



// WEBPACK FOOTER //
// ./src/store/general/index.js